/**
 * SEO Component for page-specific meta tags
 * Uses React 19's native document metadata support
 */
const SEO = ({ 
  title, 
  description, 
  canonical, 
  noindex = false 
}) => {
  const baseUrl = "https://birk-anlaeg.dk";
  const fullTitle = title.includes("Birk Anlæg") ? title : `${title} | Birk Anlæg`;
  const canonicalUrl = canonical ? `${baseUrl}${canonical}` : baseUrl;
  const robotsContent = noindex ? "noindex, nofollow" : "index, follow";
  
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robotsContent} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
    </>
  );
};

export default SEO;
